<div class="app-Root__container">
  <router-outlet></router-outlet>
</div>
